import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Spinner from 'react-bootstrap/Spinner';
import { connect } from 'react-redux';
import { apiSections } from 'dmpconnectjsapp-base/constants';
import { getUserConfiguration } from 'dmpconnectjsapp-base/helpers/accessors';
import { getErrorDescription } from '../../dmpconnect/errors';
import { login, monitorLicenseAfterForm } from '../../dmpconnect/actions';

class CheckLicense extends Component {
  constructor(props) {
    super(props);

    this.state = {
      remainingTimeBeforeLicenceCheck: 0,
    };
  }

  componentDidMount() {
    this.startLicenceMonitoring();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { licenseOkAfterForm, licenseCheckLoading } = this.props;
    const { licenseOkAfterForm: prevLicenseOkAfterForm, licenseCheckLoading: prevLicenseCheckLoading } = prevProps;

    if (!prevLicenseOkAfterForm && licenseOkAfterForm) {
      this.clearIntervals();
      this.autoLoginTimeout = setTimeout(() => this.autoLogin(), 5000);
    }

    if (prevLicenseCheckLoading && !licenseCheckLoading) {
      this.startLicenceMonitoring();
    }
  }

  componentWillUnmount() {
    this.clearIntervals();
  }

  clearIntervals() {
    clearTimeout(this.checkTimeout);
    clearTimeout(this.autoLoginTimeout);
    clearInterval(this.countDownInterval);
  }

  startLicenceMonitoring() {
    const { dispatch } = this.props;
    clearInterval(this.countDownInterval);
    clearTimeout(this.checkTimeout);
    this.setState({ remainingTimeBeforeLicenceCheck: 15 });
    this.checkTimeout = setTimeout(() => {
      dispatch(monitorLicenseAfterForm());
    }, 15000);
    this.countDownInterval = setInterval(
      () => this.setState(prevState => ({
        remainingTimeBeforeLicenceCheck: prevState.remainingTimeBeforeLicenceCheck - 1,
      })),
      1000,
    );
  }

  autoLogin() {
    const { dispatch, practiceSetting, practiceLocationSetting } = this.props;
    dispatch(
      login({
        pinCode: null,
        practiceSetting,
        cpsPracticeLocationIndice: practiceLocationSetting,
        auto: true,
      }),
    );
  }

  render() {
    const {
      error,
      s_given,
      s_internalId,
      s_name,
      licenseOkAfterForm,
      licenseCheckLoading,
    } = this.props;
    const { remainingTimeBeforeLicenceCheck } = this.state;
    const errorDesc = getErrorDescription(error);
    return (
      <Card id="invalid-license">
        {licenseOkAfterForm ? (
          <Card.Body>
            <Card.Title>
              Licence active détectée.
            </Card.Title>
            <Card.Text>Votre licence est maintenant active.</Card.Text>
            <Card.Text>Vous allez être connecté à l&apos;application</Card.Text>
          </Card.Body>
        ) : (
          <>
            <Card.Header>{errorDesc.title}</Card.Header>
            <Card.Body>
              <Card.Text>
                Vous devez disposer d&apos;une licence active pour utiliser cette application.
                <br />
              </Card.Text>
              <Card.Text>
                Pour acquérir ou renouveler votre licence, veuillez contacter votre éditeur.
                <br />
                En laissant la page actuelle ouverte, vous serez automatiquement connecté à l&apos;application à l&apos;activation de la licence.
              </Card.Text>
              <div>
                <Card.Text>
                  Informations de la carte :
                </Card.Text>
                <ul>
                  <li>
                    <Row>
                      <Col sm={2}>Nom</Col>
                      <Col>{s_name}</Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm={2}>Prénom</Col>
                      <Col>{s_given}</Col>
                    </Row>
                  </li>
                  <li>
                    <Row>
                      <Col sm={2}>Identifiant</Col>
                      <Col>{s_internalId}</Col>
                    </Row>
                  </li>
                </ul>
              </div>
            </Card.Body>
          </>
        )}
        {!licenseOkAfterForm ? (
          <Card.Footer className="text-center">
            {licenseCheckLoading === true ? (
              <>
                Vérification de la licence en cours
                <Spinner
                  className="ml-4"
                  as="span"
                  animation="border"
                  role="status"
                  aria-hidden="true"
                />
              </>
            ) : (
              <>
                Prochaine vérification de la licence dans
                {' '}
                {remainingTimeBeforeLicenceCheck}
                {' '}
                seconde
                {remainingTimeBeforeLicenceCheck > 1 ? 's' : ''}
                {/* <i className="la la-hourglass-half detection"/> */}
              </>
            )}
          </Card.Footer>
        ) : (
          <Card.Footer className="text-center">
            Connexion en cours
            <Spinner animation="border" className="ml-3" />
          </Card.Footer>
        )}
      </Card>
    );
  }
}

CheckLicense.propTypes = {
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.object.isRequired,
  s_given: PropTypes.string,
  s_internalId: PropTypes.string,
  s_name: PropTypes.string,
  licenseOkAfterForm: PropTypes.bool,
  practiceSetting: PropTypes.string,
  practiceLocationSetting: PropTypes.string,
  licenseCheckLoading: PropTypes.bool,
};

CheckLicense.defaultProps = {
  s_given: '',
  s_internalId: '',
  s_name: '',
  licenseOkAfterForm: false,
  practiceSetting: '',
  practiceLocationSetting: '',
  licenseCheckLoading: false,
};

function mapStateToProps(state) {
  const {
    dmpconnect: {
      [apiSections.CPX_CARD_SECTION]: cpxCard,
    },
    dmpconnectCPxConfiguration,
    dmpconnectInit: {
      licenseOkAfterForm,
      licenseCheckLoading,
    },
  } = state;
  const {
    s_given,
    s_internalId,
    s_name,
  } = cpxCard;

  return {
    s_given,
    s_internalId,
    s_name,
    licenseOkAfterForm,
    licenseCheckLoading,
    practiceSetting: getUserConfiguration(cpxCard, 'practiceSetting', dmpconnectCPxConfiguration),
    practiceLocationSetting: getUserConfiguration(cpxCard, 'practiceLocationSetting', dmpconnectCPxConfiguration),
  };
}

const connectedCheckLicense = connect(mapStateToProps)(CheckLicense);

export default connectedCheckLicense;
